import { MRT_ColumnDef } from "material-react-table"
import { useMemo } from "react"
import { format } from "date-fns"

interface UseTableColumnsReporteClientesValoresSoftnetProps {
    pagination?: { pageIndex: number; pageSize: number };
}

export const useTableColumnsReporteClientesValoresSoftnet = (props?: UseTableColumnsReporteClientesValoresSoftnetProps) => {
    const { pagination } = props || {};

    const columnBase = useMemo<MRT_ColumnDef<any>[]>(() => [
        {
            accessorKey: 'numero',
            header: '#',
            size: 60,
            enableColumnFilter: false,
            Cell: ({ row }) => {
                // Calcular número absoluto basado en la página actual
                const baseNumber = pagination ? (pagination.pageIndex * pagination.pageSize) : 0;
                return baseNumber + row.index + 1;
            },
        },
        {
            accessorKey: 'idContrato',
            header: 'Contrato #',
            size: 100,
            Cell: ({ cell }) => cell.getValue<number>() || '-',
        },
        {
            accessorKey: 'fecha_instalacion',
            header: 'Fecha Instalación',
            size: 150,
            Cell: ({ cell }) => {
                const fecha = cell.getValue() as string;
                if (fecha) {
                    try {
                        // Se agrega 'T00:00:00' para evitar problemas de zona horaria al parsear "YYYY-MM-DD"
                        return format(new Date(`${fecha}T00:00:00`), 'yyyy-MM-dd');
                    } catch {
                        return fecha;
                    }
                }
                return '-';
            },
        },
        {
            accessorKey: 'fecha_cambio',
            header: 'Fecha Cancelación',
            size: 150,
            Cell: ({ cell }) => {
                const fecha = cell.getValue() as string;
                if (fecha) {
                    try {
                        // Se agrega 'T00:00:00' para evitar problemas de zona horaria al parsear "YYYY-MM-DD"
                        return format(new Date(`${fecha}T00:00:00`), 'yyyy-MM-dd');
                    } catch {
                        return fecha;
                    }
                }
                return 'No Aplica';
            },
        },
        {
            accessorKey: 'num_documento',
            header: 'IDENTIFICACION',
            size: 250,
            Cell: ({ cell }) => cell.getValue<string>() || '-',
        },
        {
            accessorKey: 'nombre_cliente',
            header: 'Nombre Cliente',
            size: 250,
            Cell: ({ cell }) => cell.getValue<string>() || '-',
        },
        {
            accessorKey: 'descripcion',
            header: 'Estado Contrato',
            size: 250,
            Cell: ({ cell }) => cell.getValue<string>() || '-',
        },
        {
            accessorKey: 'plan_internet',
            header: 'Plan Contratado',
            size: 250,
            Cell: ({ cell }) => cell.getValue<string>() || '-',
        },
        {
            accessorKey: 'valor',
            header: 'Valor Mensual Sin Imp',
            size: 250,
            Cell: ({ cell }) => cell.getValue<string>() || '-',
        },
        {
            accessorKey: 'forma_pago',
            header: 'Forma de Pago',
            size: 250,
            Cell: ({ cell }) => cell.getValue<string>() || '-',
        },
        {
            accessorKey: 'departamento_ventas',
            header: 'Departamento de Ventas',
            size: 250,
            Cell: ({ cell }) => cell.getValue<string>() || '-',
        },
        {
            accessorKey: 'nombre_vendedor',
            header: 'Nombre Vendedor',
            size: 250,
            Cell: ({ cell }) => cell.getValue<string>() || '-',
        },
        {
            accessorKey: 'fec_nacimiento',
            header: 'Fecha de Nacimiento',
            size: 250,
            Cell: ({ cell }) => cell.getValue<string>() || '-',
        },
        {
            accessorKey: 'calificacion_buro',
            header: 'Calificación Buró',
            size: 250,
            Cell: ({ cell }) => cell.getValue<string>() || '-',
        },
        {
            accessorKey: 'total_deuda',
            header: 'Total Deuda',
            size: 250,
            Cell: ({ cell }) => cell.getValue<string>() || '-',
        },
    ], [pagination]);

    return {
        columnBase
    }
}
